class TagLanguageSwitcher {
  // 1. describe and create/initiate our object
  constructor() {
    this.pageLanguage = document.documentElement.lang;
    this.appliance = document.querySelector("#appliance-type");
    this.languageSwitcher = document.querySelector(".wpml-ls-link");
    this.baseURL = this.languageSwitcher.href;
    this.setTargetLanguage();
    this.events();
  }

  // 2. events
  events() {
    if (this.appliance) {
      this.applianceSlug = this.appliance.dataset.tag;
      this.newURL = this.baseURL + 'servicio/' + this.applianceSlug;
      this.languageSwitcher.setAttribute('href', this.newURL);
    } 
      console.log(this.newURL);

  }

  // 3. methods (function, action...)
  setTargetLanguage() {
    if(this.pageLanguage === 'es-ES') {
      this.targetLanguage = 'ca';
    } else {
      this.targetLanguage = 'es';
    }
  } 
  
}

export default TagLanguageSwitcher